import React from "react";
import { PointedText, PointedWord } from "../../models";
import { Chant } from "../Chant";
import { getTone } from "../tones";
import { getNotesFromString } from "../utils";

export const ToneDiagram: React.FC<{
    toneId: string;
    highlightCount: number;
}> = (props) => {
    const { toneId, highlightCount } = props;

    const tone = getTone(toneId);

    if (!tone) {
        return <></>;
    }

    const processNotes = (notes: string[]): PointedWord[] => {
        return notes
            .filter((noteString) => !noteString.includes("?"))
            .map((noteString) => {
                return {
                    syllables: [
                        {
                            text: "    ",
                            notes: getNotesFromString(
                                noteString.replace("~", "")
                            ),
                            long: noteString
                                .replace(/[\?\~]/, "")
                                .includes("."),
                            dotBefore: false,
                        },
                    ],
                };
            });
    };

    const secondReciting: PointedWord[] = [
        {
            syllables: [
                {
                    text: "        ",
                    notes: [`${tone.secondRecitingNote ?? tone.recitingNote}`],
                    long: false,
                    dotBefore: false,
                    reciting: true,
                },
            ],
        },
    ];

    let secondHalf = secondReciting;

    secondReciting.push(
        ...processNotes(tone.endingOptions?.[0] ?? tone.ending)
    );

    const pointedText: PointedText = {
        clef: tone.clef,
        verses: [
            {
                firstHalf: processNotes(tone.intonation)
                    .concat([
                        {
                            syllables: [
                                {
                                    text: "        ",
                                    notes: [`${tone.recitingNote}`],
                                    long: false,
                                    dotBefore: false,
                                    reciting: true,
                                },
                            ],
                        },
                    ])
                    .concat(processNotes(tone.mediant)),
                secondHalf,
            },
        ],
    };

    return (
        <div className="tone-diagram">
            <Chant
                pointedText={pointedText}
                boldMode="all"
                dropCap={false}
                highlightCount={highlightCount}
                noPadding
                tone={toneId}
            />
        </div>
    );
};
